import Dashboard from '@mui/icons-material/StackedBarChartOutlined';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import { RootState } from '@/redux/store';
import CO2Deliveries from '@/sections/Statistics/CO2Deliveries/CO2Deliveries';
import { DateProvider } from '@/sections/Statistics/Context/DateProvider';
import DateFilters from '@/sections/Statistics/DateFilters/DateFilters';
import FastestDeliveries from '@/sections/Statistics/FastestDeliveries/FastestDeliveries';
import FirstShipment from '@/sections/Statistics/FirstShipment/FirstShipment';
import FrequentlyStates from '@/sections/Statistics/FrequentlyStates/FrequentlyStates';
import ShipmentBreakdown from '@/sections/Statistics/ShipmentBreakdown/ShipmentBreakdown';
import ShipmentDelivered from '@/sections/Statistics/ShipmentDelivered/ShipmentDelivered';
import ShipmentStatistics from '@/sections/Statistics/ShipmentStatistics/ShipmentStatistics';
import UnsuccessfulDeliveries from '@/sections/Statistics/UnsuccessfulDeliveries/UnsuccessfulDeliveries';
import UnsuccessfulPickups from '@/sections/Statistics/UnsuccessfulPickups/UnsuccessfulPickups';

const Home = () => {
  usePageTitle('Estadísticas');

  const { profile } = useSelector((state: RootState) => state.parcel);
  const country = profile.data?.country;

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Estadísticas" mt={5}>
        <Dashboard fontSize="large" />
      </SectionTitle>

      <FirstShipment />

      <DateProvider>
        <DateFilters />
        <ShipmentStatistics />
        <Grid container spacing={2} mt={2}>
          <Grid size={{ xxs: 12, sm: 6 }}>
            <ShipmentDelivered />
          </Grid>
          <Grid size={{ xxs: 12, sm: 6 }}>
            <ShipmentBreakdown />
          </Grid>
          {country === 'MEX' && (
            <Grid size={{ xxs: 12, sm: 6 }}>
              <FrequentlyStates />
            </Grid>
          )}
          <Grid size={{ xxs: 12, sm: 6 }}>
            <FastestDeliveries />
          </Grid>
          <Grid size={{ xxs: 12, sm: 6 }}>
            <CO2Deliveries />
          </Grid>
          <Grid size={{ xxs: 12, sm: 6 }}>
            <UnsuccessfulDeliveries />
          </Grid>
          <Grid size={{ xxs: 12 }}>
            <UnsuccessfulPickups />
          </Grid>
        </Grid>
      </DateProvider>
    </Container>
  );
};

export default Home;
